import { brand, alpha } from '@/styles/shared';

export const silenceWarningStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 9998,
    backdropFilter: 'blur(2px)',
  },

  popup: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: `0px 8px 32px rgba(248, 3, 3, 0.3), 0px 0px 0px 3px ${alpha.red10}`,
    padding: {
      xs: '32px 24px',
      sm: '40px 48px',
    },
    maxWidth: {
      xs: '90vw',
      sm: '500px',
    },
    width: '100%',
    animation: 'silenceBlink 3s ease-in-out infinite',
    border: `2px solid ${brand.redAlert}`,
    '@keyframes silenceBlink': {
      '0%, 100%': {
        opacity: 1,
        transform: 'translate(-50%, -50%) scale(1)',
      },
      '33%': {
        opacity: 0.7,
        transform: 'translate(-50%, -50%) scale(0.98)',
      },
      '66%': {
        opacity: 1,
        transform: 'translate(-50%, -50%) scale(1)',
      },
    },
  },

  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    color: 'rgba(0, 0, 0, 0.6)',
    '&:hover': {
      backgroundColor: alpha.red10,
      color: brand.redAlert,
    },
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },

  icon: {
    fontSize: {
      xs: '56px',
      sm: '72px',
    },
    color: brand.redAlert,
  },

  title: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: {
      xs: '22px',
      sm: '28px',
    },
    lineHeight: 1.3,
    color: brand.redAlert,
    textAlign: 'center',
    marginBottom: '16px',
  },

  message: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: {
      xs: '15px',
      sm: '16px',
    },
    lineHeight: 1.5,
    color: '#000000',
    textAlign: 'center',
    marginBottom: '24px',
  },

  subtitle: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.8)',
    marginBottom: '12px',
  },

  checkList: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    lineHeight: 1.8,
    color: 'rgba(0, 0, 0, 0.7)',
    paddingLeft: '24px',
    margin: 0,
    '& li': {
      marginBottom: '6px',
    },
  },
};
